Object.defineProperty(exports, "__esModule", {
  value: true
});

// Customizable Area Start
exports.productApiContentType = "application/json";
exports.apiMethodTypeGet = "GET";
exports.productAPiEndPoint = "catalogue/catalogues";
exports.SortAPiEndPoint = "sorting/sorting";
exports.SortAscAPiEndPoint = "sorting/sorting?sort[order_by]=price&sort[direction]=asc";
exports.SortDescAPiEndPoint = "sorting/sorting?sort[order_by]=price&sort[direction]=desc";
exports.SortNewestAPiEndPoint = "sorting/sorting?sort[order_by]=created_at&sort[direction]=desc";
exports.SortPopularityAPiEndPoint = "sorting/sorting?sort[order_by]=average_rating&sort[direction]=desc";
exports.labelTitleText = "sorting";
exports.labelBodyText = "sorting Body";
exports.btnExampleTitle = "CLICK ME";
// Customizable Area End